export default "__VITE_ASSET__Buv7zdmY__"